import React, {useState} from "react";
import {ISelectType} from "../interfaces/ISelectType";

type ListingSortingType = {
  selectedSortingOptionCtx: ISelectType | null,
  setSelectedSortingOptionCtx: React.Dispatch<React.SetStateAction<ISelectType | null>>
}

export const ListingSortingContext = React.createContext<ListingSortingType>({} as ListingSortingType)

export function ListingSortingProvider({children}: any) {
  const [selectedSortingOptionCtx, setSelectedSortingOptionCtx] = useState<ISelectType | null>(null)

  return (
    <ListingSortingContext.Provider value={{selectedSortingOptionCtx, setSelectedSortingOptionCtx}}>
      {children}
    </ListingSortingContext.Provider>
  )
}